import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DataTable from '@components/DataTable/DataTable'

// Maps react-url-query functions to generic DataTable functions
// note: react-url-query should be instantiated outside and props passed in

class RemoteDataTable extends Component {

	static propTypes = {
		// values
		search: PropTypes.string,
		page: PropTypes.number,
		limit: PropTypes.number,
		// change handlers
		onchangeSearch: PropTypes.func,
		onChangePage: PropTypes.func,
		onChangeUrlQueryParams: PropTypes.func,
		pushInUrlQuery: PropTypes.func,
	}

	onChangeFilter = (values) => {
		const { onChangeUrlQueryParams } = this.props;
		onChangeUrlQueryParams(values);
	}

	onChangePerPage = (limit) => {
		const { onChangeUrlQueryParams } = this.props;
		onChangeUrlQueryParams({
			limit: limit,
			page: 1,
		})
	} 

	onChangeSort = (sortKey, sortDir) => {
		const { onChangeUrlQueryParams } = this.props;
		onChangeUrlQueryParams({ 
			sortBy: sortKey, 
			sortDir: sortDir,
			page: 1,
		});
	}

	render() {
		return <DataTable 
			{...this.props} 
			onChangeFilter={this.onChangeFilter}
			onChangePerPage={this.onChangePerPage}
			onChangeSort={this.onChangeSort}
		/>
	}

}

export default RemoteDataTable;


// WEBPACK FOOTER //
// ./src/components/RemoteDataTable/RemoteDataTable.jsx